const links = [
  { label: "About Us", href: "#about", testId: "nav-link-about" },
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export const Navbar = () => (
  <header
    data-testid="navbar"
    className="sticky top-0 z-50 border-b border-border bg-background/90 backdrop-blur-md"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
      <a
        href="#top"
        data-testid="nav-logo"
        className="font-sans text-sm font-medium tracking-[0.3em] uppercase"
      >
        Lakeview Music
      </a>
      <nav className="flex items-center gap-8">
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            data-testid={link.testId}
            className="link-underline text-xs font-medium tracking-[0.2em] uppercase text-foreground/70 hover:text-foreground"
          >
            {link.label}
          </a>
        ))}
      </nav>
    </div>
  </header>
);
